const sortAlphabetically = (list = [], accessor = a => a, lang = "en") =>
  list.sort((a, b) => accessor(a).localeCompare(accessor(b), lang));

export default sortAlphabetically;
